export default class NewsletterSignup {

    constructor(elm) {

        const signUpButtons = elm.querySelectorAll('.footer__newsletter-submit');
        const submitMessage = document.querySelector('.newsletter__submitmessage');

        for (let i = 0; i < signUpButtons.length; i++) {
            signUpButtons[i].addEventListener('click', e => {

                e.preventDefault();
                signup();

            });
        }


        async function signup() {

            submitMessage.innerText = '';
            submitMessage.classList.remove('iserror');

            const email = elm.querySelector('.footer__newsletter-email').value;
            const segment = elm.querySelector('.footer__newsletter-select').value;
            //     var permission = document.querySelector('#permission').checked;

            if (!email) {
                submitMessage.classList.add('iserror');
                submitMessage.innerText = 'Husk at udfylde din email-adresse.';
                return;
            }

            if (segment === '') {
                submitMessage.classList.add('iserror');
                submitMessage.innerText = 'Vælg hvilken liste du vil modtage.';
                return;
            }
            /*
            if (permission == false) {
                submitMessage.classList.add('iserror');
                submitMessage.innerText = 'Husk at læse og godkende privatlivspolitikken nedenfor.';
                return;
            }
            */
            const data = {
                email: email,
                segment: segment,
            };

            const responseText = await fetch('/Umbraco/Api/Newsletter/Signup', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify(data),
            });
            const response = await responseText.json();

            if (response.isSuccess === false) {
                submitMessage.classList.add('iserror');
            } else {
               // elm.querySelector('.newsletter__input-email').value = '';
                elm.querySelector('.footer__newsletter-email').value = '';
                elm.querySelector('#newsletter-permission-checkbox').checked = false;
                //elm.querySelector('#horingssvar').checked = false;
                //document.querySelector('#permission').checked = false;
            }
            submitMessage.innerText = response.message;
        }
    }
}
